const WorkspaceInfo = {
    canvasInfo : [],
    setWorkspaceInfo(data){
        this.canvasInfo = data
    },
    getWorkspacInfo(){
        return this.canvasInfo;
    }
}

export const WorkspaceAppsInfo = {
    appInfo : [],
    setWorkspaceSoftwareList(data){
        this.appInfo = data;
    },
    getWorkspaceSoftwareList(){
        return this.appInfo;
    }
}

export const SwipedInformation = {
    swipedData : null,
    setSwipedInData(data){
        this.swipedData = data;
    },
    getSwipedInData() {
        return this.swipedData;
    }
}

export default WorkspaceInfo;